import { MainButton, LimitReachedCard, ModuleLimitDetail } from "commonUI";
import { OpenLinkIcon } from "allIcons";
import "./Sites.css";
import { useSites } from "api/sites";
import { isEqual } from "helpers";
import { t } from "i18next";
import { useUserLimitReached } from "hooks/plan";
import { UnlimitedPlanValue } from "enums/plans";

export default function SiteCard({ className, ...props }) {
  const { data = {} } = useSites();
  const { storage_details, site_details } = data;
  const { isLoading, isLimitReached, usagePercentage, totalUsers, members } =
    useUserLimitReached();

  // if (isLoading) return <></>;

  return (
    <>
      <div className={`site-card border-2 border-theme-card-bg ${className}`}>
        {/* Sites details */}
        {isLoading ? (
          ""
        ) : (
          <LimitReachedCard
            show={isEqual(
              site_details?.sites_limit,
              site_details?.total_used_site
            )}
            title={t("sites.siteUsageDetail.limitReached.title")}
            description={t("sites.siteUsageDetail.limitReached.body")}
          />
        )}
        <ModuleLimitDetail
          title={t("sites.siteUsageDetail.title")}
          isLoading={props.isLoading || isLoading}
          description={props.sites.description}
          progress={props.sites.line}
        />
        {/* Users details */}
        {isLoading ? (
          ""
        ) : (
          <LimitReachedCard
            show={isLimitReached}
            title={t("users.limitReached.title")}
            description={t("users.limitReached.description")}
          />
        )}
        <ModuleLimitDetail
          title="Users"
          description={
            isEqual(totalUsers, UnlimitedPlanValue)
              ? t("sites.usersUsageDetail.unlimitedUsers", {
                  currentUsers: members,
                })
              : t("sites.usersUsageDetail.body", {
                  currentUsers: members,
                  totalUsers: totalUsers,
                  usagePercentage: Number(usagePercentage).toFixed(2),
                })
          }
          progress={usagePercentage}
          isLoading={props.isLoading || isLoading}
        />
        {/* Storage Details */}
        {isLoading ? (
          ""
        ) : (
          <LimitReachedCard
            show={isEqual(
              storage_details?.storage_limit,
              storage_details?.total_used_storage
            )}
            title={t("sites.storageUsageDetail.limitReached.title")}
            description={t("sites.storageUsageDetail.limitReached.body")}
          />
        )}
        <ModuleLimitDetail
          title={t("sites.storageUsageDetail.title")}
          isLoading={props.isLoading || isLoading}
          description={props.storage.description}
          progress={props.storage.line}
        />
        <a
          href="https://wpsitelauncher.com/customer-dashboard/?action=index&model=subscription"
          target="_blank"
          rel="noreferrer"
        >
          <MainButton>
            <OpenLinkIcon />
            {t("common.button.managePlan")}
          </MainButton>
        </a>
      </div>
    </>
  );
}
